// extracted by mini-css-extract-plugin
export var dateLabel = "_3g-0";
export var dateLabelError = "_3g-1";
export var fullWidth = "_3g-2";
export var smaller = "_3g-3";